import { useEffect, useState, useCallback } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || window.location.origin;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) arr[i] = raw.charCodeAt(i);
  return arr;
}

export default function useVapidPush(userId) {
  const [permission, setPermission] = useState(
    typeof Notification !== 'undefined' ? Notification.permission : 'default'
  );
  const [subscribed, setSubscribed] = useState(false);

  const subscribe = useCallback(async () => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
    if (!userId) return;

    try {
      const resp = await fetch(`${API_BASE}/api/push-vapid-key`);
      const { publicKey } = await resp.json();
      if (!publicKey) return;

      const registration = await navigator.serviceWorker.ready;
      let sub = await registration.pushManager.getSubscription();

      if (!sub) {
        const result = await Notification.requestPermission();
        setPermission(result);
        if (result !== 'granted') return;

        sub = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(publicKey),
        });
      } else {
        setPermission('granted');
      }

      await fetch(`${API_BASE}/api/push-subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          subscription: sub.toJSON(),
          userId,
          userType: 'client',
        }),
      });

      setSubscribed(true);
    } catch (e) {
      console.warn('[VapidPush] Subscribe failed:', e);
    }
  }, [userId]);

  useEffect(() => {
    if (!userId) return;
    const alreadyDone = sessionStorage.getItem('vtd_vapid_subscribed');
    if (alreadyDone) {
      setSubscribed(true);
      return;
    }

    const timer = setTimeout(() => {
      if (Notification.permission === 'granted') {
        subscribe();
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [userId, subscribe]);

  useEffect(() => {
    if (subscribed) sessionStorage.setItem('vtd_vapid_subscribed', '1');
  }, [subscribed]);

  return { permission, subscribed, subscribe };
}
